import { Attribute } from '../asd-attribute';

export class RowItem {
  DisplayName: string;
  ID: string;
  ColItems: ColItem[];
}

export class ColItem {
  Name: string;
  Value: any;
  BaseValue: any;
  nil: boolean;
  Type: any;
  class: any;
}

export class HeaderItem {
  Name: any;
  ToolTipText: any;
  DisplayName: string;
  CosyDataTypeDID: any;
  SystemDataType: any;
  AllowSorting: boolean;
  Editable:boolean;
  Attributes: Attribute;
  Items:  {DisplayName: string;ID: string;Visible: boolean} [] = [];
}
